import { CdkStepper } from '@angular/cdk/stepper';
import { Pipe, PipeTransform } from '@angular/core';
import { isPresent } from '@mtna/core-ts';

/**
 * Check to see if the stepper is on the last step of a MatStepper.
 *
 * @author Will Davis <will.davis@mtna.us>
 */
@Pipe({
  name: 'rdsOnLastStep',
})
export class OnLastStepPipe implements PipeTransform {
  /**
   * @param currentStep the index of the currently selected step
   * @param stepper the CdkStepper
   * @returns whether the stepper is on the last step
   */
  transform(currentStep: number | null | undefined, stepper: CdkStepper | null | undefined): boolean {
    if (!isPresent(currentStep) || !isPresent(stepper)) {
      return false;
    }
    return currentStep === stepper.steps.length - 1;
  }
}
